<template>
    <v-container fluid>
        <slot></slot>
    </v-container>
</template>
<script>
    export default {}
</script>